import React from 'react';
import { Button, ButtonParamType, DefaultButtonStyle } from '../button/revamp-button';
import './navigation-bar-footer.scss';

export function NavigationBarFooter({
  onBack = () => {},
  onNext = () => {},
  nextEnabled = false,
  backEnabled = false,
  nextButtonLabel = 'Next',
  backButtonLabel = 'Back',
  showBack = false,
  showNext = false,
  softDisable = true,
}) {
  const backButton = () => {
    return (
      <Button
        disabled={!backEnabled}
        buttonStyle={DefaultButtonStyle().hasSecondaryAction().isSmallSize().hasLightMode().build()}
        buttonParams={{
          type: ButtonParamType.NormalButton,
          onClick: () => {
            onBack();
          },
        }}
        className="back-button"
        automationid={`Revamp_Footer_${backButtonLabel}_Button`}
      >
        {backButtonLabel}
      </Button>
    );
  };
  function nextButton(enabled: boolean) {
    return (
      <Button
        disabled={!enabled}
        softDisable={softDisable}
        buttonStyle={DefaultButtonStyle().hasPrimaryAction().isSmallSize().hasLightMode().build()}
        buttonParams={{
          type: ButtonParamType.NormalButton,
          onClick: () => {
            onNext();
          },
        }}
        className="next-button"
        automationid={`Revamp_Footer_${nextButtonLabel}_Button`}
      >
        {nextButtonLabel}
      </Button>
    );
  }

  return (
    <div className="NavigationBarFooter">
      <div className="footer-navigation level show-desktop-only">
        <div>{showBack && backButton()}</div>
        <div>{showNext && nextButton(nextEnabled)}</div>
      </div>

      <div className="footer-navigation show-mobile-only is-mobile">
        <div className="container field">
          <div className="columns is-mobile space-evenly">
            <div id="mobile-footer-secondary-button" />
            <div id="mobile-footer-next-button">{showNext && nextButton(nextEnabled)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
